import React, { PropsWithChildren } from "react";

import Box from "@mui/material/Box";
import { ClassNameMap } from "@mui/material/styles";

import "swiper/css/bundle";

import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { Swiper, SwiperSlide } from "~/lib/swiper/component";

import { STORE_CAROUSEL_CLASSES } from "./constants";
import { StoreCarouselContainer } from "./styled";

export interface StoreCarouselProps {
  classes?: Partial<ClassNameMap>;
}

export const StoreCarousel: React.FC<PropsWithChildren<StoreCarouselProps>> = ({
  children,
  classes: externalClasses,
}) => {
  return (
    <StoreCarouselContainer
      className={externalClasses?.root}
      {...getTestAutomationProps("store-carousel")}
    >
      <Box
        className={STORE_CAROUSEL_CLASSES.elements}
        {...getTestAutomationProps("elements")}
      >
        <Swiper
          initialSlide={0}
          spaceBetween={0}
          slidesPerView="auto"
          autoHeight={true}
        >
          {React.Children.map(children, (element, index) => (
            <SwiperSlide
              key={`store-carousel-element-${index}`}
              className={STORE_CAROUSEL_CLASSES.element}
              {...getTestAutomationProps("element")}
            >
              <Box className={STORE_CAROUSEL_CLASSES.elementWrapper}>{element}</Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </StoreCarouselContainer>
  );
};
